/** PostHog event helpers — no-ops when SDK is not loaded. */

export function capturePartnerEvent(name, props = {}) {
  try {
    window.posthog?.capture(name, props);
  } catch {
    /* analytics must never break app flows */
  }
}

export function identifyPartnerUser(userId, props = {}) {
  if (!userId) return;
  try {
    window.posthog?.identify(String(userId), props);
  } catch {
    /* ignore */
  }
}
